<template>
        <div>
            <div
                v-if="showOverlay && hasOverlay"
                class="video__overlay"
                v-on:click="play"
                v-on:keyup.enter="play"
            >
                <div class="video__overlay-button" tabindex="0">
                    <div class="video__overlay-button--inner"></div>
                </div>
            </div>
            <div class="video" ref="video">
                <video class="hero-video-mp4" playsinline controls ref="videoMP4" v-if="videoType === 'mp4'">
                    <source :src="url" type="video/mp4" />
                </video>
            </div>
        </div>
</template>

<script>
import Vue from 'vue';
import VideoBase from '../global/VideoBase';
import Youtube from '../global/Youtube';
import Vimeo from '../global/Vimeo';
import MP4Video from '../global/MP4Video';
import ThemeBase from '../ThemeBase';

export default Vue.extend({
    props: {
        theme: ThemeBase,
        hero: Boolean,
        videoType: {
            type: String,
            required: true,
            validator: function (value) {
                return ['youtube', 'vimeo', 'mp4'].indexOf(value) !== -1
            },
        },
        url: {
            type: String,
            required: true,
        },
        autoplay: {
            type: Boolean,
            required: true,
        },
        loop: Boolean,
        mute: Boolean,
        hasOverlay: {
            type: Boolean,
            default: false,
        },
        hideControls: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            /** @type {VideoBase} */
            player: null,
            showOverlay: true
        };
    },
    mounted() {
        if (this.videoType === 'youtube') {
            this.player = new Youtube(this.theme, this.$refs.video);
        } else if (this.videoType === 'vimeo') {
            this.player = new Vimeo(this.theme, this.$refs.video);
        } else if (this.videoType === 'mp4') {
            this.player = new MP4Video(this.theme, this.$refs.videoMP4);
        }

        if (!this.player) return;

        this.player.init({
            autoplay: this.autoplay,
            hideControls: this.hideControls,
            url: this.url,
            mute: this.mute,
            loop: this.loop,
            onPlay: this.onPlay,
            onEnd: this.onEnd,
            hero: this.hero
        });
    },
    methods: {
        onPlay() {
        },
        onEnd() {
        },
        play() {
            this.player.play();
            this.showOverlay = false;
        }
    }
})
</script>